module.exports = __webpack_public_path__ + "img/r3.c7f16bbb.jpg";